import React from 'react';

import { ArrowIcon } from '../svg';

import styles from './styles.module.scss';

export const ExternalLink: React.FC<sharedComponents.ExternalLink> = ({
  text,
  link,
  withIcon = true,
  analytics,
  analyticsType,
  className,
  target = '_blank',
  iconClassName,
}) => (
  <a
    className={className || styles.link}
    href={link}
    target={target}
    rel="noopener noreferrer"
    data-analytics-link={analytics}
    data-analytics-link-type={analyticsType}
  >
    {text}
    {withIcon && <ArrowIcon height={8} width={8} className={iconClassName} />}
  </a>
);
